import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { ProjectRoleService } from '../../services/project-role.service';

export const testlaufLeserRedirectGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const roles = inject(ProjectRoleService);
  const projectId = route.pathFromRoot.reduce((found, step) => step.paramMap.get('projectId') ?? found, '');

  // Guards run before the resolver of ':projectId', so the role has to be loaded here.
  return roles
    .ensureLoaded(projectId)
    .pipe(
      map(() =>
        roles.isArchived() || (roles.isProjectReader() && !roles.isTenantAdmin())
          ? router.createUrlTree(['/projects', projectId, 'test-runs'])
          : true,
      ),
    );
};
